import { createAppHostApi } from './hostApi';
import * as ownerReporting from '../apps/owner-reporting';

/**
 * Discover and register in-repo marketplace apps.
 * v1: explicit import list (no remote code loading).
 */
export const loadMarketplaceApps = () => {
  const apps = [ownerReporting];
  apps.forEach(plugin => {
    if (!plugin || typeof plugin.register !== 'function') return;
    const code = plugin.code || (plugin.manifest && plugin.manifest.code);
    const app = createAppHostApi(code);
    plugin.register(app);
  });
};

let loaded = false;
export const ensureMarketplaceAppsLoaded = () => {
  if (loaded) return;
  loadMarketplaceApps();
  loaded = true;
};
